import {
  getSchema as getSchema1,
  uiSchema as uiSchema1,
} from "./schema.followUpPhone.1";

export default (defaultValues?: { [key: string]: any }) => [
  { schema: getSchema1(defaultValues || {}), uiSchema: uiSchema1() },
];
